import { Money } from '@ynab/core'
import { money } from '../api.ts'

/** Full amount with cents, for any column of figures. */
export function fmt(amount: number): string {
  return Money.format(money(amount))
}

/** Whole dollars, for labels and headlines where cents are noise. */
export function fmtWhole(amount: number): string {
  return Money.format(money(amount), { hideDecimals: true })
}

/** Zero renders as an em dash, the way a ledger does. */
export function fmtDash(amount: number): string {
  return Money.format(money(amount), { dashForZero: true })
}

/** Editable value for an assign input: plain decimal, no symbol. */
export function toInput(amount: number): string {
  return Money.toUnits(money(amount)).toFixed(2)
}

/**
 * "27 Jul" — the compact date the register and the scheduled list both use.
 *
 * Formatted in UTC deliberately. These are calendar dates stored as `YYYY-MM-DD`,
 * not instants, so parsing one and rendering it in the browser's zone would shift
 * a date backwards for anyone west of the meridian.
 */
export function shortDate(isoDate: string): string {
  const date = new Date(
    Date.UTC(
      Number(isoDate.slice(0, 4)),
      Number(isoDate.slice(5, 7)) - 1,
      Number(isoDate.slice(8, 10)),
    ),
  )
  return new Intl.DateTimeFormat('en-NZ', {
    day: 'numeric',
    month: 'short',
    timeZone: 'UTC',
  }).format(date)
}
